import DealsAPI from './deals-api';

export const RECEIVE_DEALS = 'RECEIVE_DEALS';
export const RECEIVE_DEALS_ERROR = 'RECEIVE_DEALS_ERROR';
export const DEALS_HYDRATING = 'DEALS_HYDRATING';
export const DEALS_HYDRATED = 'DEALS_HYDRATED';

export const receiveDeals = (deals) => ({
	type: RECEIVE_DEALS,
	deals
});
export const receiveDealsError = () => ({
	type: RECEIVE_DEALS_ERROR
});

const dealsAPI = new DealsAPI();


export const fetchDeals = (ids, force) => (dispatch, getState) => {
	let { deals, userData } = getState();
	const { profileData } = userData;
	const { personData } = profileData || {};
	const { pStoreID } = personData || {};

	//requests to fetch deals if deals already fetched
	//unless force is true
	if(userData.userIdle || (deals.dealsFetched && !force)){
		return;
	}
	return dealsAPI.fetchDeals(pStoreID).then(resp => {
		const { hydrating, dealRefreshInterval, deals } = resp;
		if(!hydrating){
			if(dealRefreshInterval &&  dealRefreshInterval > -1){
				setTimeout(() => {
					fetchDeals(undefined, true)(dispatch, getState);
				}, dealRefreshInterval);
			}
			return dispatch(receiveDeals(deals));
		}
	}).catch(err => {
		dispatch(receiveDealsError(err))
	})
};
